import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <h4 className="font-heading text-xl font-bold text-white mb-4">
              52662鼎盛平台
            </h4>
            <p className="text-sm leading-relaxed text-background-50/60 max-w-xs">
              官方认证正规平台，致力于为用户提供安全、稳定、高效的服务体验。选择鼎盛，选择信赖。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-lg" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link></li>
              <li><Link to="/category" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">分类浏览</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link></li>
              <li><a href="#download" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">官方下载</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">服务支持</h4>
            <ul className="flex flex-col gap-2.5">
              <li><a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">新手指南</a></li>
              <li><a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">常见问题</a></li>
              <li><a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">安全保障</a></li>
              <li><a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户协议</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">联系我们</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2.5">
                <i className="ri-customer-service-line text-primary-400 mt-0.5" />
                <span className="text-sm text-background-50/60">客服热线：400-XXX-XXXX</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line text-primary-400 mt-0.5" />
                <span className="text-sm text-background-50/60">support@52662dingsheng.com</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line text-primary-400 mt-0.5" />
                <span className="text-sm text-background-50/60">服务时间：7×24小时</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 52662鼎盛平台官方版 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}